var routes = {
    "":                                     "/pages/home/controller",
    "error":                                "/pages/error/controller",
    "error/{error_code}":                   "/pages/error/controller",
    "form/{form_id}":                       "/pages/form/controller",
    "invoice/{event_id}/{permalink}":       "/pages/invoice/view/controller",
    "invoice/{event_id}/{permalink}/pay":   "/pages/invoice/pay/controller",
    "pd/{access_key}":                      "/pages/proposal-viewer/controller",
    "proposal/generating/{access_key}":     "/pages/proposal-generating/controller",
};